export default __webpack_public_path__ + "static/media/seu-problema-resolvido.1d2b4b72.png";